// extracted by mini-css-extract-plugin
export default {"inlineAnnotation":"InlineAnnotation-module__inlineAnnotation--bVDzc"};